import { Credentials } from 'aws-sdk/lib/core';
import { WebAuth } from 'auth0-js';

import { AUTH0_CLIENT_ID, AUTH0_DOMAIN } from '../config/auth0-config';

class Auth0AmazonCredentials extends Credentials {
  constructor(auth0Token, iamRole, iamProvider) {
    super();
    this.expired = true;

    this.auth0Params = {
      id_token: auth0Token,
      role: iamRole,
      principal: iamProvider,
    };

    this.auth0 = new WebAuth({
      domain: AUTH0_DOMAIN,
      clientID: AUTH0_CLIENT_ID,
    });
  }

  refresh(callback) {
    this.auth0.getDelegationToken(this.auth0Params, (err, result) => {
      if (err) {
        callback(err);
      } else {
        const awsToken = result.Credentials;
        this.expired = false;
        this.accessKeyId = awsToken.AccessKeyId;
        this.secretAccessKey = awsToken.SecretAccessKey;
        this.sessionToken = awsToken.SessionToken;
        this.expireTime = new Date(awsToken.Expiration);
        callback();
      }
    });
  }
}

export default Auth0AmazonCredentials;
